export default __webpack_public_path__ + "static/plp--reposado-dff3a984e3a96c5be96aa55113bafe31.jpg";